import { isEqual } from "lodash";
import { useState } from "react";

import { AbsencesPeriodQuickFilter } from "./interfaces";

export const useAbsencesPeriodQuickFilter = () => {
  const [quickFilter, setQuickFilter] = useState<AbsencesPeriodQuickFilter>({
    absencesPeriod: {
      fromDate: null,
      toDate: null,
    },
  });

  const handleChangeQuickFilter = (
    filter: keyof AbsencesPeriodQuickFilter,
    value: AbsencesPeriodQuickFilter["absencesPeriod"]
  ) => {
    if (isEqual(value, quickFilter[filter])) return;

    setQuickFilter((state) => ({ ...state, [filter]: value }));
  };

  return {
    absencesPeriodQuickFilter: quickFilter,
    setAbsencesPeriodQuickFilter: handleChangeQuickFilter,
  };
};
